export default __webpack_public_path__ + "static/media/Class-10-State-Math.5d893359.pdf";